import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function CaseStudyCard({ content }) {
  const { t } = useLanguage();
  const metrics = Array.from({ length: 3 })
    .map((_, i) => ({
      value: content?.[`metric_value_${i + 1}`],
      label: content?.[`metric_label_${i + 1}`],
    }))
    .filter((m) => m.value);

  if (!content?.case_study_title) return null;

  return (
    <section data-testid="case-study-section" className="bg-cream py-section sm:py-section-lg border-t border-mist">
      <div className="container-page">
        <Reveal
          as="article"
          className="overflow-hidden rounded-3xl border border-mist bg-white"
          data-testid="case-study-card"
        >
          <div className="grid gap-0 lg:grid-cols-12">
            <div className="lg:col-span-5 relative bg-noir text-cream p-10 sm:p-14 flex flex-col justify-between min-h-[300px]">
              <div className="pointer-events-none absolute inset-0 bg-grain-dark opacity-50" />
              <div className="pointer-events-none absolute -top-24 -end-24 h-[280px] w-[280px] rounded-full bg-gold/15 blur-3xl" />
              <span className="relative eyebrow-on-dark">
                <span className="h-1 w-1 rounded-full bg-gold" />
                {content.case_study_eyebrow || t("service.case_study_eyebrow")}
              </span>
              <div className="relative font-display text-display-2 font-semibold text-cream leading-[1.1]">
                <span className="gold-foil-text">{metrics[0]?.value || "★"}</span>
              </div>
              <p className="relative text-xs uppercase tracking-[0.22em] text-cream/50">
                {metrics[0]?.label}
              </p>
            </div>

            <div className="lg:col-span-7 p-10 sm:p-14">
              <h3 className="font-display text-h1 font-semibold text-ink leading-tight">
                {content.case_study_title}
              </h3>
              <p className="mt-5 text-body-lg text-ink/70 leading-relaxed max-w-xl">
                {content.case_study_body}
              </p>
              <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-6">
                {metrics.map((m, i) => (
                  <div key={i} className="border-t border-mist pt-4">
                    <div className="font-display text-3xl sm:text-4xl font-semibold text-ink">{m.value}</div>
                    <p className="mt-1 text-xs uppercase tracking-[0.18em] text-ink/55 max-w-[12ch]">
                      {m.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
